// Conversas salvas no servidor (consultas/suporte_ia). A sessão vai no cookie; `authFetch` renova o token.
import { API_BASE_URL, authFetch } from "../api";

export const API = `${API_BASE_URL}/suporte-ia`;
const BASE = `${API}/conversas/`;

async function ler(url) {
  const r = await authFetch(url, { cache: "no-store" });
  if (!r.ok) throw new Error(`Não foi possível carregar suas conversas (erro ${r.status}).`);
  return r.json();
}

export const listarConversas = () => ler(BASE);
export const abrirConversa = (id) => ler(`${BASE}${encodeURIComponent(id)}/`);

/** Pode seguir escrevendo: aberta e não congelada (48h parada). */
export const continuavel = (c) => c.status === "aberta" && !c.congelada;

class Congelada extends Error {}

/**
 * Grava em ordem (fila): cria a conversa no 1º evento (ou continua `idInicial`). Falha comum para
 * de gravar e chama `falhou`; 409 (conversa congelada) chama `congelou`.
 */
export function criarGravador(falhou, congelou, idInicial = "") {
  const post = async (url, corpo) => {
    const r = await authFetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(corpo),
    });
    if (r.status === 409) throw new Congelada();
    if (!r.ok) throw new Error(String(r.status));
    return r.status === 204 ? null : r.json().catch(() => null);
  };
  let id = idInicial;
  let fila = Promise.resolve();
  let ok = true;
  const enfileirar = (fn) => {
    fila = fila
      .then(() => (ok ? fn() : undefined))
      .catch((e) => {
        if (!ok) return;
        ok = false;
        if (e instanceof Congelada) congelou();
        else falhou();
      });
    return fila.then(() => (ok ? id : ""));
  };
  const garantir = async () => {
    if (!id) id = (await post(BASE, { nova: true }))?.id ?? "";
    if (!id) throw new Error("sem id");
  };
  return {
    id: () => id,
    garantir: () => enfileirar(garantir),
    /** `estado`: fase do chat, para retomar depois de recarregar a página. */
    registrar: (eventos, estado) =>
      enfileirar(async () => {
        await garantir();
        await post(`${BASE}${id}/eventos/`, estado ? { eventos, estado } : { eventos });
      }),
    encerrar: (resumo) =>
      enfileirar(async () => {
        if (id) await post(`${BASE}${id}/encerrar/`, { resumo });
      }),
  };
}
